import { useState } from 'react';
import Reveal from '@/components/base/Reveal';
import { faqs } from '@/mocks/home';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full border-t border-background-300/70 bg-background-100 py-20 md:py-28">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16">
          <Reveal>
            <div className="lg:sticky lg:top-[128px]">
              <div className="flex items-center gap-2 text-[12px] tracking-[0.28em] text-primary-600">
                <span className="h-px w-6 bg-primary-500" />
                06 / 常见问题
              </div>
              <h3 className="mt-3 font-heading text-[30px] font-black tracking-tight text-foreground-950 md:text-[38px]">
                关于黑料免费
              </h3>
              <p className="mt-3 max-w-[380px] text-[14px] leading-relaxed text-foreground-600">
                关于是否需要付费、更新频率与榜单口径，这里集中说明。若还有疑问，欢迎通过线索入口联系编辑。
              </p>
            </div>
          </Reveal>

          <Reveal delay={100}>
            <div className="flex flex-col">
              {faqs.map((faq, index) => {
                const isOpen = openIndex === index;
                return (
                  <div key={faq.q} className="border-b border-background-300/70">
                    <button
                      type="button"
                      onClick={() => setOpenIndex(isOpen ? null : index)}
                      className="flex w-full cursor-pointer items-center justify-between gap-4 py-5 text-left"
                    >
                      <span
                        className={`text-[15px] font-medium transition-colors md:text-[17px] ${
                          isOpen ? 'text-primary-600' : 'text-foreground-900'
                        }`}
                      >
                        {faq.q}
                      </span>
                      <span
                        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full border transition-colors ${
                          isOpen
                            ? 'border-primary-300 bg-primary-50 text-primary-600'
                            : 'border-background-300 text-foreground-500'
                        }`}
                      >
                        <i className={isOpen ? 'ri-subtract-line text-[15px]' : 'ri-add-line text-[15px]'} />
                      </span>
                    </button>
                    {isOpen && (
                      <p className="pb-6 pr-10 text-[14px] leading-relaxed text-foreground-600">{faq.a}</p>
                    )}
                  </div>
                );
              })}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}